import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { InsightsMessage, MessagingCardViewModel } from 'src/common/models';

import { InsightsCard } from 'components/common/insights-card';
import { Lazy } from 'components/common/lazy/lazy';

interface RegionCompressionCardProps {
  analytics?: AnalyticsStore;
  compression?: InsightsMessage;
  iconBasedCompression?: MessagingCardViewModel;
}

export const RegionCompressionCard: React.FunctionComponent<RegionCompressionCardProps> = ({
  analytics,
  compression,
  iconBasedCompression
}) => {
  const compressionMessage = getCompressionMessage(compression, iconBasedCompression);

  React.useEffect(() => {
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent('RegionCompression.Display', 'Display', analytics.omnitureData);
    }
  }, []);

  const { heading, icon, subHeading } = compressionMessage;

  return (
    <Viewport>
      <ViewSmall>
        <Lazy>
          <Lazy.Placeholder>
            <div data-stid="region-compression-placeholder" />
          </Lazy.Placeholder>
          <Lazy.Loaded>
            <InsightsCard data-stid="insights-card" heading={heading} icon={icon} subHeading={subHeading} />
          </Lazy.Loaded>
        </Lazy>
      </ViewSmall>
      <ViewMedium>
        <InsightsCard data-stid="insights-card" heading={heading} icon={icon} subHeading={subHeading} />
      </ViewMedium>
    </Viewport>
  );
};

RegionCompressionCard.displayName = 'RegionCompressionCard';

const getCompressionMessage = (compression, iconBasedCompression) => {
  if (iconBasedCompression) {
    return {
      heading: iconBasedCompression.titleModel && iconBasedCompression.titleModel.text,
      icon: iconBasedCompression.titleModel && iconBasedCompression.titleModel.icon,
      subHeading: iconBasedCompression.subtitleModel && iconBasedCompression.subtitleModel.text
    };
  }

  return {
    heading: compression.heading,
    subHeading: compression.subHeading
  };
};
